import { render, staticRenderFns } from "./AllowedResourceSearch.vue?vue&type=template&id=73b2a4a2"
import script from "./AllowedResourceSearch.vue?vue&type=script&lang=js"
export * from "./AllowedResourceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports